import Keycloak from "keycloak-js";

const url = import.meta.env.VITE_KEYCLOAK_URL?.replace(/\/$/, "");
const realm = import.meta.env.VITE_KEYCLOAK_REALM;
const clientId = import.meta.env.VITE_KEYCLOAK_CLIENT_ID;

const keycloak = new Keycloak({
  clientId: clientId ?? "",
  realm: realm ?? "",
  url: url ?? "",
});

export default keycloak;
